import React, { useContext, useState } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { AuthUserContext } from "../context/context";
import { useTranslation } from "react-i18next";
import OtpVerification from "../page/otpVerification";

const PhoneNumberverifyModal = ({ show,setIsModalShow }) => {
  const { currentLocalization } = useContext(AuthUserContext);
  const { t } = useTranslation();
  const handleClose = ()=>{}
  return (
    <div>
      <Modal
        show={show}
        centered
        className="registration-modal"
        style={{ borderRadius: "8px" }}
      >
        <Modal.Header
          closeButton={false}
          className="custom-header pt-4 -b-4 align-items-center"
        >
          <h2
            className={`login-welcome-registrpopup ${
              currentLocalization == "ar" && "flex-row-reverse"
            }`}
          >
            {t("otpVerification.part1")}
          </h2>
          <button
            type="button"
            className="custom-close-btn"
            onClick={() => {setIsModalShow(false)}}
            aria-label="Close"
          >
            &times;
          </button>
        </Modal.Header>

        <Modal.Body className="no-padding">
          <Row>
            <Col>
              <OtpVerification
                hideSidebar={true}
                isModal={true}
                handleClose={handleClose}
                setIsModalShow={setIsModalShow}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PhoneNumberverifyModal;
